import { Section, stagger, slug } from "./Section";

const GROUPS = [
  {
    label: "Leadership & Technical Team",
    people: [
      ["Mr. Nereo Mella", "NM", "President", "40+"],
      ["Mr. Reynaldo Reynaldo", "RR", "Director, QA/QC", "40+"],
      ["Atty. Robert Cauilan", "RC", "Corporate Secretary", "40+"],
      ["Mr. Vivek Jayakumar", "VJ", "Director, Strategy", "20+"],
      ["Mr. Roger Chua", "RC", "Senior Technical Advisor", "40+"],
    ],
  },
  {
    label: "Business Team",
    people: [
      ["Mr. Dexter Bautista", "DB", "Business Development Officer", "15+"],
      ["Ms. Nicole Gutierrez", "NG", "Business Support Officer", "3+"],
    ],
  },
];

const Member = ({ p, i }) => {
  const [name, initials, title, yrs] = p;
  return (
    <li className="team-card reveal-item flex flex-col items-start text-left" style={stagger(i)} data-testid={`team-member-${slug(name)}`}>
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[#E8EEFF] text-[11px] font-medium text-[#1B3A6B]" role="img" aria-label={`Photo placeholder for ${name}`}>{initials}</div>
      <p className="mt-5 whitespace-nowrap text-[12px] font-medium leading-snug text-[#111111]">{name}</p>
      <p className="mt-2 text-[12px] leading-snug text-[#4A5568]">{title}</p>
      <p className="mt-2 text-[11px] leading-snug text-[#4A5568]">{yrs} years of experience</p>
    </li>
  );
};

export const Team = () => (
  <Section id="team" className="bg-[#E8EEFF]" testId="team-section">
    <h2 className="als-heading is-centered text-center" data-testid="section-heading-team">Our team</h2>
    <p className="mx-auto mt-6 max-w-[560px] text-center text-[15px] leading-[1.7] text-[#4A5568]" data-testid="team-intro">
      ALS is led by professionals with experience across energy, infrastructure, project execution, quality assurance,
      legal, strategy and business development.
    </p>
    {GROUPS.map((g, gi) => (
      <div key={g.label} className={gi === 0 ? "mt-8" : "mt-12"} data-testid={`team-group-${slug(g.label)}`}>
        <p className="als-sublabel mb-6 text-center">{g.label}</p>
        <ul className="flex flex-wrap justify-center gap-5">
          {g.people.map((p, i) => <Member key={p[0]} p={p} i={i} />)}
        </ul>
      </div>
    ))}
  </Section>
);
